import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("sub_"), S.String).pipe(S.annotations({
    identifier: "@open-revenue/schema/stripe/SubscriptionId",
    description: "The id of the subscription in Stripe",
    examples: [
        "sub_1234567890"
    ]
}));
export const make = (subscriptionId)=>S.decodeUnknown(Schema)(subscriptionId);
export const makeUnsafe = (subscriptionId)=>subscriptionId;
